import React, { useState } from "react";
import { Box, Paper, Button, Typography, Switch, FormControlLabel, FormGroup } from "@mui/material";
import ImpressionScatterplot from "./ImpressionScatterplot";
import ImpressionDayOfWeek from "./ImpressionDayOfWeek";
import ImpressionMonthly from "./ImpressionMonthly";
import ImpressionLineChart from "./ImpressionLineChart";
// A placeholder for your actual graph components
const GraphPlaceholder = ({ title, dataType, billboardId }) => (
  <Box sx={{ p: 4, minHeight: 400, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
    <Typography variant="h5" gutterBottom>{title}</Typography>
    <Typography variant="body1">Displaying: **{dataType}** data</Typography>
    <Typography variant="caption">For Billboard ID: {billboardId}</Typography>
  </Box>
);


const ImpressionMetricsView = ({ billboardId }) => {
  const [selectedGraphView, setSelectedGraphView] = useState("daily");
  const [dataType, setDataType] = useState({
    impressions: true,
    traffic: false,
  });

  const handleDataTypeChange = (event) => {
    setDataType({
      ...dataType,
      [event.target.name]: event.target.checked,
    });
  };

  const graphViews = [
    { key: "daily", label: "Time of the Day" },
    { key: "dayOfWeek", label: "Day of the Week" },
    { key: "monthly", label: "Monthly" },
    { key: "dailyAverage", label: "Daily Avg" },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        {/* Data Type Toggles */}
        <FormGroup>
          <FormControlLabel
            control={<Switch checked={dataType.impressions} onChange={handleDataTypeChange} name="impressions" />}
            label="Impressions data"
          />
          <FormControlLabel
            control={<Switch checked={dataType.traffic} onChange={handleDataTypeChange} name="traffic" />}
            label="Traffic data"
          />
        </FormGroup>

        {/* Graph Timeframe Selection Buttons */}
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, flexGrow: 1 }}> {/* <-- Add flexGrow: 1 here */}
          {graphViews.map((view) => (
            <Button
              key={view.key}
              variant={selectedGraphView === view.key ? "contained" : "outlined"}
              onClick={() => setSelectedGraphView(view.key)}
              sx={{ borderRadius: "20px", px: 3, textTransform: 'none' }}
            >
              {view.label}
            </Button>
          ))}
        </Box>
      </Box>

      {/* Graph Display */}
      <Paper variant="outlined">
        {selectedGraphView === "daily" && <ImpressionScatterplot billboardId={billboardId} />}
        {selectedGraphView === "dayOfWeek" && <ImpressionDayOfWeek billboardId={billboardId}/>}
        {selectedGraphView === "monthly" && <ImpressionMonthly billboardId={billboardId} />}
        {selectedGraphView === "dailyAverage" && <ImpressionLineChart billboardId={billboardId} />}
      </Paper>
    </Box>
  );
};

export default ImpressionMetricsView;